(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellore-home-product-slider-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBelloreHomeSliders = () => {
      document.querySelectorAll('[data-bhs]:not([data-bhs-ready])').forEach((root) => {
        root.dataset.bhsReady = 'true';
        const viewport = root.querySelector('[data-bhs-viewport]');
        const prev = root.querySelector('[data-bhs-prev]');
        const next = root.querySelector('[data-bhs-next]');
        const hasOverflow = () => viewport && viewport.scrollWidth > viewport.clientWidth + 2;
        const atStart = () => viewport.scrollLeft <= 2;
        const atEnd = () => viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        const updateArrows = () => {
          const enabled = hasOverflow();
          prev.disabled = !enabled;
          next.disabled = !enabled;
        };
        if (viewport) {
          prev.addEventListener('click', () => {
            viewport.scrollTo({ left: atStart() ? viewport.scrollWidth : viewport.scrollLeft - viewport.clientWidth, behavior: 'smooth' });
          });
          next.addEventListener('click', () => {
            viewport.scrollTo({ left: atEnd() ? 0 : viewport.scrollLeft + viewport.clientWidth, behavior: 'smooth' });
          });
          viewport.addEventListener('scroll', updateArrows, { passive: true });
          window.addEventListener('resize', updateArrows);
          updateArrows();
        } else {
          prev.hidden = true;
          next.hidden = true;
        }

        const favoriteKey = 'bellore_collection_favorites';
        const favorites = () => { try { return JSON.parse(localStorage.getItem(favoriteKey) || '[]'); } catch { return []; } };
        const syncFavorites = () => root.querySelectorAll('[data-bhs-favorite]').forEach((button) => {
          const active = favorites().includes(button.dataset.bhsFavorite);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        syncFavorites();

        root.addEventListener('click', async (event) => {
          const favorite = event.target.closest('[data-bhs-favorite]');
          if (favorite) {
            event.preventDefault();
            if (root.dataset.customerAuthenticated !== 'true') {
              if (window.confirm('You need to sign in to add favourites. Would you like to go to the sign-in page?')) {
                location.href = root.dataset.loginUrl + '?return_url=' + encodeURIComponent(location.pathname);
              }
              return;
            }
            const list = favorites();
            const id = favorite.dataset.bhsFavorite;
            localStorage.setItem(favoriteKey, JSON.stringify(list.includes(id) ? list.filter((item) => item !== id) : [...list, id]));
            syncFavorites();
            return;
          }

          const button = event.target.closest('[data-bhs-add]');
          if (!button || button.disabled) return;
          event.preventDefault();
          button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: button.dataset.bhsAdd, quantity: 1 }] })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'The product could not be added to the cart.');
            button.classList.add('is-added');
            window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          } catch (error) {
            button.disabled = false;
            window.alert(error.message);
          }
        });

        root.addEventListener('pointerover', (event) => event.target.closest('.bhs-card')?.querySelector('video.bhs-card__video')?.play().catch(() => {}));
        root.addEventListener('pointerout', (event) => {
          const video = event.target.closest('.bhs-card')?.querySelector('video.bhs-card__video');
          if (video) { video.pause(); video.currentTime = 0; }
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBelloreHomeSliders, { once: true });
    else initBelloreHomeSliders();
    document.addEventListener('shopify:section:load', initBelloreHomeSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellore-home-product-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBelloreHomeSliders = () => {
      document.querySelectorAll('[data-bhs]:not([data-bhs-ready])').forEach((root) => {
        root.dataset.bhsReady = 'true';
        const viewport = root.querySelector('[data-bhs-viewport]');
        const prev = root.querySelector('[data-bhs-prev]');
        const next = root.querySelector('[data-bhs-next]');
        const updateArrows = () => {
          if (!viewport) return;
          prev.disabled = viewport.scrollLeft <= 2;
          next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
        };
        if (viewport) {
          prev.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' }));
          next.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' }));
          viewport.addEventListener('scroll', updateArrows, { passive: true });
          window.addEventListener('resize', updateArrows);
          updateArrows();
        } else {
          prev.hidden = true;
          next.hidden = true;
        }

        const favoriteKey = 'bellore_collection_favorites';
        const favorites = () => { try { return JSON.parse(localStorage.getItem(favoriteKey) || '[]'); } catch { return []; } };
        const syncFavorites = () => root.querySelectorAll('[data-bhs-favorite]').forEach((button) => {
          const active = favorites().includes(button.dataset.bhsFavorite);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        syncFavorites();

        root.addEventListener('click', async (event) => {
          const favorite = event.target.closest('[data-bhs-favorite]');
          if (favorite) {
            event.preventDefault();
            if (root.dataset.customerAuthenticated !== 'true') {
              if (window.confirm('You need to sign in to add favourites. Would you like to go to the sign-in page?')) {
                location.href = root.dataset.loginUrl + '?return_url=' + encodeURIComponent(location.pathname);
              }
              return;
            }
            const list = favorites();
            const id = favorite.dataset.bhsFavorite;
            localStorage.setItem(favoriteKey, JSON.stringify(list.includes(id) ? list.filter((item) => item !== id) : [...list, id]));
            syncFavorites();
            return;
          }

          const button = event.target.closest('[data-bhs-add]');
          if (!button || button.disabled) return;
          event.preventDefault();
          button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: button.dataset.bhsAdd, quantity: 1 }] })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'The product could not be added to the cart.');
            button.classList.add('is-added');
            window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          } catch (error) {
            button.disabled = false;
            window.alert(error.message);
          }
        });

        root.addEventListener('pointerover', (event) => event.target.closest('.bhs-card')?.querySelector('video.bhs-card__video')?.play().catch(() => {}));
        root.addEventListener('pointerout', (event) => {
          const video = event.target.closest('.bhs-card')?.querySelector('video.bhs-card__video');
          if (video) { video.pause(); video.currentTime = 0; }
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBelloreHomeSliders, { once: true });
    else initBelloreHomeSliders();
    document.addEventListener('shopify:section:load', initBelloreHomeSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellore-horizontal-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* Bellore hiz duzeltmesi (02.10): video sayfa acilisinda degil, bolum ekrana yaklasinca yuklenir. */
    const MOBILE_QUERY = '(max-width: 749px)';
    const activeVideoOf = (media) => {
      const mobile = media.querySelector('.bhv__video--mobile');
      if (mobile && matchMedia(MOBILE_QUERY).matches) return mobile;
      return media.querySelector('.bhv__video--desktop');
    };
    const pickSource = (video) => {
      const list = [...video.querySelectorAll('source[data-src]')]
        .map((s) => ({ url: s.dataset.src, h: parseInt(s.dataset.h, 10) || 0 }))
        .filter((s) => s.url)
        .sort((a, b) => a.h - b.h);
      if (!list.length) return null;
      const target = matchMedia(MOBILE_QUERY).matches ? 480 : 720;
      let pick = list[0];
      list.forEach((s) => { if (s.h && s.h <= target) pick = s; });
      return pick.url;
    };
    const loadVideo = (video) => {
      if (!video || video.dataset.bhvLoaded) return;
      const url = pickSource(video);
      if (!url) return;
      video.dataset.bhvLoaded = 'true';
      video.preload = video.hasAttribute('data-bhv-autoplay') ? 'auto' : 'metadata';
      video.src = url;
      video.load();
    };
    const playVideo = (video) => {
      if (!video) return;
      if (video.hasAttribute('muted')) video.muted = true;
      const result = video.play();
      if (result && result.catch) result.catch(() => {});
    };
    let observer = null;
    let started = false;
    const pending = new Set();
    const onIntersect = (entries) => {
      entries.forEach((entry) => {
        const video = activeVideoOf(entry.target);
        if (!video) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          loadVideo(video);
          if (video.hasAttribute('data-bhv-autoplay')) playVideo(video);
        } else if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    };
    const observe = (media) => {
      if (!started) { pending.add(media); return; }
      if (observer) { observer.observe(media); return; }
      const video = activeVideoOf(media);
      loadVideo(video);
      if (video && video.hasAttribute('data-bhv-autoplay')) playVideo(video);
    };
    const start = () => {
      if (started) return;
      started = true;
      if ('IntersectionObserver' in window) observer = new IntersectionObserver(onIntersect, { threshold: [0, 0.25] });
      pending.forEach(observe);
      pending.clear();
    };
    const initBelloreVideos = () => {
      document.querySelectorAll('[data-bhv-media]:not([data-bhv-ready])').forEach((media) => {
        media.dataset.bhvReady = 'true';
        const activeVideo = () => activeVideoOf(media);
        const button = media.querySelector('[data-bhv-play]');
        const sync = () => media.classList.toggle('is-playing', Boolean(activeVideo() && !activeVideo().paused));
        if (button) {
          button.addEventListener('click', () => {
            const video = activeVideo();
            if (!video) return;
            if (video.paused) { loadVideo(video); playVideo(video); }
            else video.pause();
            setTimeout(sync);
          });
        }
        media.querySelectorAll('video').forEach((video) => {
          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
        });
        sync();
        observe(media);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBelloreVideos, { once: true });
    else initBelloreVideos();
    document.addEventListener('shopify:section:load', (event) => { start(); initBelloreVideos(event); });
    if (document.readyState === 'complete' || (window.Shopify && window.Shopify.designMode)) start();
    else {
      window.addEventListener('load', start, { once: true });
      setTimeout(start, 3500);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellore-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBelloreCollections = () => {
      document.querySelectorAll('[data-bc-section]:not([data-bc-ready])').forEach((bcRoot) => {
        bcRoot.setAttribute('data-bc-ready', 'true');
        const auth = bcRoot.dataset.customerAuthenticated === 'true';
        const favoriteKey = 'bellore_collection_favorites';
        const getFavorites = () => { try { return JSON.parse(localStorage.getItem(favoriteKey) || '[]'); } catch { return []; } };
        const setFavorites = (items) => localStorage.setItem(favoriteKey, JSON.stringify(items));
        const syncFavorites = () => {
          const favorites = getFavorites();
          bcRoot.querySelectorAll('[data-favorite]').forEach((button) => {
            const active = favorites.includes(button.dataset.favorite);
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        };
        syncFavorites();

        bcRoot.addEventListener('click', async (event) => {
          const favorite = event.target.closest('[data-favorite]');
          if (favorite) {
            event.preventDefault();
            if (!auth) {
              if (window.confirm('You need to sign in to add favourites. Would you like to go to the sign-in page?')) {
                window.location.href = bcRoot.dataset.loginUrl + '?return_url=' + encodeURIComponent(location.pathname + location.search);
              }
              return;
            }
            const favorites = getFavorites();
            const id = favorite.dataset.favorite;
            setFavorites(favorites.includes(id) ? favorites.filter((item) => item !== id) : [...favorites, id]);
            syncFavorites();
            return;
          }

          const button = event.target.closest('[data-add-variant]');
          if (!button || button.disabled) return;
          event.preventDefault();
          button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: button.dataset.addVariant, quantity: 1 }] })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'The product could not be added to the cart.');

            button.classList.add('is-added');
            window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          } catch (error) {
            button.disabled = false;
            window.alert(error.message);
          }
        });

        bcRoot.addEventListener('pointerover', (event) => {
          event.target.closest('.bc-card')?.querySelector('video.bc-hover-video')?.play().catch(() => {});
        });
        bcRoot.addEventListener('pointerout', (event) => {
          const video = event.target.closest('.bc-card')?.querySelector('video.bc-hover-video');
          if (video) { video.pause(); video.currentTime = 0; }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBelloreCollections, { once: true });
    } else {
      initBelloreCollections();
    }
    document.addEventListener('shopify:section:load', initBelloreCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellore-main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBelloreCollections = () => {
      document.querySelectorAll('[data-bc-section]:not([data-bc-ready])').forEach((bcRoot) => {
        bcRoot.setAttribute('data-bc-ready', 'true');
        const auth = bcRoot.dataset.customerAuthenticated === 'true';
        const favoriteKey = 'bellore_collection_favorites';
        const getFavorites = () => { try { return JSON.parse(localStorage.getItem(favoriteKey) || '[]'); } catch { return []; } };
        const setFavorites = (items) => localStorage.setItem(favoriteKey, JSON.stringify(items));
        const syncFavorites = () => {
          const favorites = getFavorites();
          bcRoot.querySelectorAll('[data-favorite]').forEach((button) => {
            const active = favorites.includes(button.dataset.favorite);
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
        };
        syncFavorites();

        bcRoot.addEventListener('click', async (event) => {
          const favorite = event.target.closest('[data-favorite]');
          if (favorite) {
            event.preventDefault();
            if (!auth) {
              if (window.confirm('You need to sign in to add favourites. Would you like to go to the sign-in page?')) {
                window.location.href = bcRoot.dataset.loginUrl + '?return_url=' + encodeURIComponent(location.pathname + location.search);
              }
              return;
            }
            const favorites = getFavorites();
            const id = favorite.dataset.favorite;
            setFavorites(favorites.includes(id) ? favorites.filter((item) => item !== id) : [...favorites, id]);
            syncFavorites();
            return;
          }

          const button = event.target.closest('[data-add-variant]');
          if (!button || button.disabled) return;
          event.preventDefault();
          button.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: button.dataset.addVariant, quantity: 1 }] })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'The product could not be added to the cart.');

            button.classList.add('is-added');
            window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          } catch (error) {
            button.disabled = false;
            window.alert(error.message);
          }
        });

        bcRoot.addEventListener('pointerover', (event) => {
          event.target.closest('.bc-card')?.querySelector('video.bc-hover-video')?.play().catch(() => {});
        });
        bcRoot.addEventListener('pointerout', (event) => {
          const video = event.target.closest('.bc-card')?.querySelector('video.bc-hover-video');
          if (video) { video.pause(); video.currentTime = 0; }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBelloreCollections, { once: true });
    } else {
      initBelloreCollections();
    }
    document.addEventListener('shopify:section:load', initBelloreCollections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellore-shoppable-image"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBelloreShoppableImages = () => {
      document.querySelectorAll('[data-bsi]:not([data-bsi-ready])').forEach((root) => {
        root.dataset.bsiReady = 'true';
        const closeAll = (except) => root.querySelectorAll('[data-bsi-hotspot]').forEach((hotspot) => {
          if (hotspot === except) return;
          hotspot.classList.remove('is-active');
          hotspot.querySelector('[data-bsi-trigger]')?.setAttribute('aria-expanded', 'false');
          const card = hotspot.querySelector('[data-bsi-card]');
          if (card) card.hidden = true;
        });
        root.addEventListener('click', async (event) => {
          const trigger = event.target.closest('[data-bsi-trigger]');
          if (trigger) {
            const hotspot = trigger.closest('[data-bsi-hotspot]');
            const open = !hotspot.classList.contains('is-active');
            closeAll(hotspot);
            hotspot.classList.toggle('is-active', open);
            trigger.setAttribute('aria-expanded', String(open));
            hotspot.querySelector('[data-bsi-card]').hidden = !open;
            return;
          }
          const close = event.target.closest('[data-bsi-close]');
          if (close) { closeAll(); return; }
          const add = event.target.closest('[data-bsi-add]');
          if (!add || add.disabled) return;
          event.preventDefault();
          add.disabled = true;
          try {
            const response = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:add.dataset.bsiAdd,quantity:1}]})});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'The product could not be added to the cart.');
            add.classList.add('is-added');
            add.querySelector('span').textContent = 'Added';
            const currentCartIcon = document.querySelector('cart-icon');
            const headerSectionId = currentCartIcon?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
            const ids = ['cart-drawer-section',headerSectionId].filter(Boolean);
            const sections = await fetch('/?sections=' + ids.join(',')).then((res) => res.json());
            const holder = document.createElement('div');
            holder.innerHTML = sections['cart-drawer-section'] || '';
            const incoming = holder.querySelector('cart-items-component');
            const current = document.querySelector('cart-items-component');
            if (incoming && current) current.replaceWith(incoming);
            if (headerSectionId && sections[headerSectionId]) {
              const hh = document.createElement('div'); hh.innerHTML = sections[headerSectionId];
              const icon = hh.querySelector('cart-icon'); if (icon && currentCartIcon) currentCartIcon.replaceWith(icon);
            }
            document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            setTimeout(() => { add.disabled=false; add.classList.remove('is-added'); add.querySelector('span').textContent='Add to cart'; },1400);
          } catch(error) { add.disabled=false; window.alert(error.message); }
        });
        document.addEventListener('click', (event) => { if (!root.contains(event.target)) closeAll(); });
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initBelloreShoppableImages,{once:true}); else initBelloreShoppableImages();
    document.addEventListener('shopify:section:load',initBelloreShoppableImages);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
